module.exports = __webpack_public_path__ + "img/t-27860-011-474x316.ac52222d.jpg";